import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Time-limited "NEW" pill for feature discovery in navigation.
 */
export default function NavNewBadge({ className, compact = false }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded font-bold uppercase tracking-wide',
        'bg-emerald-600 text-white dark:bg-emerald-500',
        compact ? 'px-1 py-0 text-ds-caption leading-4' : 'px-1.5 py-0.5 text-ds-caption leading-4',
        className
      )}
      aria-label="New feature"
    >
      NEW
    </span>
  );
}
